<template>
  <integration
    :logoSrc="logoSrc"
    :label="label"
    v-model="internalActive"
    @input="updateActive()"
  >
    <tag-list
      label="Webinar key"
      :disabled="!internalActive"
      :value="internalKeys"
      :classes="['no-margin']"
      v-model="internalKeys"
      @input="updateKeys()"
    />
  </integration>
</template>
<script>
import Integration from '@/components/helpers/DataInput/integrations/Integration'
import TagList from '@/components/helpers/DataInput/TagList'

export default {
  props: {
    active: {
      type: Boolean,
      required: true
    },
    value: {
      type: Array,
      required: true
    }
  },
  components: {
    Integration,
    TagList
  },
  data() {
    return {
      label: 'go-to-webinar',
      logoSrc: 'goto-webinar',
      internalActive: this.active,
      internalKeys: this.value
    }
  },
  methods: {
    updateActive() {
      this.$emit('activeInput', this.internalActive)
    }
  },
  watch: {
    active() {
      this.internalActive = this.active
    },
    value() {
      this.internalKeys = this.value
    }
  }
}
</script>
<style lang="sass" scoped>
.no-margin
  margin-bottom: 0
</style>



// WEBPACK FOOTER //
// GoToWebinar.vue?063ed100